import React, { ReactNode } from 'react';
import { connect } from 'react-redux';

import { pushFlashMessage } from 'store/main/ducks/flashMessages';
import {
  hideGradProgram,
  unhideGradProgram,
} from 'store/main/ducks/orgDashboard/gradPrograms';
import {
  hideListing,
  unhideListing,
} from 'store/main/ducks/orgDashboard/listings';

type OwnProps = {
  listingId: string;
  listingType: string;
  orgId: string;
  render: (arg0: {
    hideListing: () => Promise<void>;
    unhideListing: () => Promise<void>;
    submitting: boolean;
  }) => ReactNode;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onHide?: (...args: Array<any>) => any;
};
type Props = OwnProps & {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hideGradProgram: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unhideGradProgram: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hideListing: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unhideListing: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pushFlashMessage: (...args: Array<any>) => any;
};
type State = {
  submitting: boolean;
};

class HideListingContainer extends React.PureComponent<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    submitting: false,
  };

  toggleListingHidden = (hide: boolean) => {
    let toggle;
    this.setState({
      submitting: true,
    });
    const { orgId, listingId, listingType } = this.props;

    // @NOTE - We have to use grad program specific redux functions,
    // though it'd be preferable to treat grad programs the same as listings
    if (listingType === 'GRAD_PROGRAM') {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      toggle = hide ? this.props.hideGradProgram : this.props.unhideGradProgram;
    } else {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      toggle = hide ? this.props.hideListing : this.props.unhideListing;
    }

    return toggle({
      orgId,
      listingId,
      listingType,
    }).then(() => {
      this.setState({
        submitting: false,
      });
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.pushFlashMessage({
        type: hide ? 'LISTING_HIDDEN' : 'LISTING_UNHIDDEN',
      });

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      if (this.props.onHide) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.onHide(hide ? 'LISTING_HIDDEN' : 'LISTING_UNHIDDEN');
      }
    });
  };

  hideListing = () => this.toggleListingHidden(true);

  unhideListing = () => this.toggleListingHidden(false);

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring, react/destructuring-assignment
    const submitting = this.state.submitting;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.render({
      hideListing: this.hideListing,
      unhideListing: this.unhideListing,
      submitting,
    });
  }
}

// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
export default connect<Props, OwnProps, _, _, _, _>(null, {
  hideListing,
  unhideListing,
  hideGradProgram,
  unhideGradProgram,
  pushFlashMessage,
})(HideListingContainer);
